import React, { useState, useEffect } from "react";
import BlogCard from "./BlogCard";
import hybridBlogService from "../../services/hybridBlogService";

const BlogGrid = ({ searchQuery = "", selectedCategory = "" }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        setLoading(true);
        setError(null);

        let blogs;
        if (searchQuery.trim()) {
          // Priority: Search query
          blogs = await hybridBlogService.searchBlogs(searchQuery);
        } else if (selectedCategory) {
          // Secondary: Category filter
          blogs = await hybridBlogService.fetchBlogsByCategory(selectedCategory);
        } else {
          // Default: All blogs
          blogs = await hybridBlogService.fetchBlogList();
        }

        setBlogPosts(blogs);
      } catch (err) {
        console.error('Error loading blogs:', err);
        setError('Failed to load blog posts. Please try again later.');

        // Fallback to empty array if GitHub fails
        setBlogPosts([]);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, [searchQuery, selectedCategory]);

  if (loading) {
    return (
      <div className="blog-grid-container">
        <div className="blog-loading">
          <div>Loading blog posts...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-grid-container">
        <div className="blog-error">
          <div>{error}</div>
        </div>
      </div>
    );
  }

  if (blogPosts.length === 0 && (searchQuery || selectedCategory)) {
    const message = searchQuery
      ? `No blog posts found for "${searchQuery}"`
      : `No blog posts found in "${selectedCategory}" category`;

    return (
      <div className="blog-grid-container">
        <div className="blog-no-results">
          <div>{message}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-grid-container">
      <div className="blog-grid">
        {blogPosts.map((post, index) => (
          <BlogCard
            key={post.slug || post.id || index}
            id={post.slug}
            title={post.title}
            description={post.excerpt}
            image={post.image}
            date={post.date}
            author={post.author}
            tags={post.tags}
            readTime={post.readTime}
          />
        ))}
      </div>
    </div>
  );
};

export default BlogGrid;
